var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.boxStyle === "full"
    ? _c(
        "div",
        [
          _c(
            "router-link",
            {
              staticClass: "text-reset d-block lh-0 text-center",
              attrs: {
                to: {
                  name: "ProductDetails",
                  params: {
                    slug: _vm.$store.getters["auth/currentUserShopSlug"],
                    productSlug: _vm.productDetails.slug,
                  },
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "h-300px", staticStyle: { overflow: "hidden" } },
                [
                  _c("img", {
                    staticClass: "border",
                    attrs: {
                      src: _vm.productDetails.thumbnail_image,
                      alt: _vm.productDetails.name,
                    },
                    on: {
                      error: function ($event) {
                        return _vm.imageFallback($event)
                      },
                    },
                  }),
                ]
              ),
            ]
          ),
        ],
        1
      )
    : _c(
        "div",
        {
          class: [
            _vm.boxStyle == "two"
              ? "product-box-two"
              : _vm.boxStyle == "three"
              ? "product-box-three"
              : _vm.boxStyle == "four"
              ? "product-box-four"
              : "product-box-one",
          ],
        },
        [
          _vm.isLoading
            ? _c(
                "div",
                [
                  _c("v-skeleton-loader", {
                    attrs: {
                      type: "image",
                      height:
                        _vm.boxStyle == "two"
                          ? "70"
                          : _vm.boxStyle == "three"
                          ? "150"
                          : _vm.boxStyle == "four"
                          ? "130"
                          : "310",
                    },
                  }),
                ],
                1
              )
            : _c("div", { staticClass: "overflow-hidden" }, [
                _c(
                  "div",
                  { staticClass: "position-relative" },
                  [
                    _vm.discount > 0 && _vm.boxStyle != "two"
                      ? _c("div", { staticClass: "discount-badge" }, [
                          _vm._v(
                            _vm._s(_vm.$t("off")) +
                              " " +
                              _vm._s(_vm.discount) +
                              "%"
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        staticClass: "text-reset d-block lh-0 text-center",
                        attrs: {
                          to: {
                            name: "ProductDetails",
                            params: {
                              slug: _vm.$store.getters[
                                "auth/currentUserShopSlug"
                              ],
                              productSlug: _vm.productDetails.slug,
                            },
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "img-fit",
                          attrs: {
                            src: _vm.productDetails.thumbnail_image,
                            alt: _vm.productDetails.name,
                          },
                          on: {
                            error: function ($event) {
                              return _vm.imageFallback($event)
                            },
                          },
                        }),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$store.getters["auth/isShowPrice"],
                          expression: "$store.getters['auth/isShowPrice']",
                        },
                      ],
                    },
                    [
                      _vm.productDetails.base_discounted_price > 0
                        ? _c(
                            "div",
                            {
                              class: [
                                _vm.boxStyle == "two"
                                  ? "order-2 fs-14 lh-1"
                                  : "fs-16 mb-2",
                              ],
                            },
                            [
                              _vm.productDetails.base_price >
                              _vm.productDetails.base_discounted_price
                                ? [
                                    _c("del", { staticClass: "opacity-40" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.format_price(
                                            _vm.productDetails.base_price
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "fw-700" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.format_price(
                                            _vm.productDetails
                                              .base_discounted_price
                                          )
                                        ) + "44"
                                      ),
                                    ]),
                                  ]
                                : [
                                    _c("span", { staticClass: "fw-700" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.format_price(
                                            _vm.productDetails
                                              .base_discounted_price
                                          )
                                        ) + "33"
                                      ),
                                    ]),
                                  ],
                            ],
                            2
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "h5",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "text-reset",
                          attrs: {
                            to: {
                              name: "ProductDetails",
                              params: {
                                slug: _vm.$store.getters[
                                  "auth/currentUserShopSlug"
                                ],
                                productSlug: _vm.productDetails.slug,
                              },
                            },
                          },
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.productDetails.name))])]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.productDetails.review_summary &&
                  _vm.generalSettings.reviews == 1
                    ? _c(
                        "div",
                        { staticClass: "review-info mt-2" },
                        [
                          _c("v-rating", {
                            attrs: {
                              "background-color": "",
                              "empty-icon": "las la-star",
                              "full-icon": "las la-star active",
                              "half-icon": "las la-star half",
                              hover: "",
                              "half-increments": "",
                              readonly: "",
                              size: "16",
                              length: "5",
                              value: _vm.productDetails.review_summary.average,
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "review-text ms-2" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  (
                                    _vm.productDetails.review_summary.average ||
                                    0
                                  ).toFixed(1)
                                ) +
                                "\n                    (" +
                                _vm._s(
                                  _vm.productDetails.review_summary.total_count
                                ) +
                                ")\n                "
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }